import { ContentSection } from "@kolibrisoftware/customerportal-ui";
import { useTranslation } from "@kolibrisoftware/hooks-util";
import usePreviewDetails from "hooks/usePreviewDetails";
import { useTheme } from "injectors/theme";
import { ObjectTabTargets } from "modules/object-preview/constants/object-tabs";
import useFoundationRiskIndicator from "modules/object-preview/hooks/useFoundationRiskIndicator";
import { FC } from "react";
import ObjectDetailsCategory from "./object-details-category";
import { useStyles } from "./styles";

type Props = {};

const ObjectDetailsSection: FC<Props> = props => {
  const theme = useTheme();
  const styles = useStyles({ theme });
  const t = useTranslation();
  const mappedPreviewDetails = usePreviewDetails();
  const { mappedFoundationRiskDetails } = useFoundationRiskIndicator();

  return (
    <>
      {!!mappedPreviewDetails && (
        <div
          className={styles.detailsSectionWrapper}
          id={ObjectTabTargets.Details}
          data-cy="ObjectPreviewDetailSection"
        >
          <ContentSection title={t("objectPreview.details.title")}>
            {Object.entries(mappedPreviewDetails).map(
              ([label, rows], index) => (
                <ObjectDetailsCategory
                  label={label}
                  rows={rows}
                  key={`detail-category-${index}`}
                />
              )
            )}

            {/* Foundation risk details (data obtained from Joey's API) */}
            <ObjectDetailsCategory
              label={t("objectPreview.details.foundationRisk.title")}
              description={t(
                "objectPreview.details.foundationRisk.description"
              )}
              rows={mappedFoundationRiskDetails}
            />
          </ContentSection>
        </div>
      )}
    </>
  );
};

export { ObjectDetailsSection };
